/* HBN Product Finder: branching quiz with % match. Used by sections/hbn-product-finder.liquid.
   Each section on the page boots its own instance from the JSON next to it. */
(function () {
  'use strict';

  /* ---------- Question tree ---------- */
  var Q = {
    start: { q: 'What would you most like support with right now?', sub: "Pick the one that matters most. We'll narrow it down from there.",
      opts: [['detox', 'Clearing out toxins and everyday buildup'], ['gut', 'My gut: balance, comfort or a full cleanse'], ['reg', 'Staying regular and feeling less backed up'], ['liver', 'My liver, energy and metabolism'], ['unsure', 'Not sure, a bit of everything']],
      next: function (s, v) { return { detox: 'exposure', gut: 'gut', reg: 'regHistory', liver: 'liverFocus', unsure: 'feel' }[v]; } },
    exposure: { q: 'How would you describe your exposure to toxins?',
      opts: [['everyday', 'Everyday', 'Food, water, city air, household products'], ['high', 'Higher than average', 'Work around metals or chemicals, an older home, or heavy past exposure'], ['unsure', 'Not sure']],
      next: function () { return 'format'; } },
    format: { q: 'How do you prefer to take supplements?',
      opts: [['capsule', 'Capsules I can take anywhere'], ['powder', 'Happy to mix a powder into water or a smoothie'], ['either', 'No preference']],
      next: function (s) { return s.branch === 'detox' ? 'intensity' : 'experience'; } },
    intensity: { q: 'What are you looking for?',
      opts: [['daily', 'A simple daily addition to my routine'], ['deep', 'A focused, deeper detox']],
      next: function () { return 'experience'; } },
    gut: { q: 'Which sounds most like you?',
      opts: [['thorough', "I'm ready for a thorough, whole-gut cleanse"], ['balance', 'I want to support a healthy gut-flora and candida balance'], ['offtrack', 'Things feel off after travel, stress or a processed-food stretch'], ['bloat', 'Mostly occasional bloating and sluggish digestion']],
      next: function (s, v) { return v === 'bloat' ? 'regHistory' : 'paraReg'; } },
    paraReg: { q: 'How are things in the regularity department?',
      opts: [['regular', 'Pretty regular'], ['sometimes', 'Sometimes sluggish'], ['often', 'Often backed up']],
      next: function () { return 'experience'; } },
    regHistory: { q: 'Have you tried a colon cleanse before?',
      opts: [['harsh', 'Yes, and it was too harsh', 'Urgent bathroom trips or cramping'], ['ok', 'Yes, it went fine'], ['never', 'Never tried one']],
      next: function () { return 'regGoal'; } },
    regGoal: { q: 'What are you after?',
      opts: [['occasional', 'Occasional regularity support'], ['fifteen', 'A full 15-day colon cleanse'], ['deeper', 'A deeper whole-gut cleanse as well']],
      next: function () { return 'experience'; } },
    liverFocus: { q: 'Which matters most to you?',
      opts: [['energy', 'Steadier, natural energy'], ['digest', 'Digestion and metabolism'], ['skin', 'Clearer-looking skin'], ['habits', 'Supporting my liver after alcohol or a processed-food stretch']],
      next: function () { return 'liverPair'; } },
    liverPair: { q: 'Would you like to pair it with a detox binder?', sub: 'Many people combine liver support with zeolite.',
      opts: [['capsule', 'Yes, in capsules'], ['powder', 'Yes, as a powder'], ['none', 'Just liver support for now']],
      next: function () { return 'experience'; } },
    feel: { q: 'Which of these do you notice lately?', sub: 'Pick all that apply.', multi: true,
      opts: [['foggy', 'Feeling run-down or foggy'], ['bloated', 'Bloating or sluggish digestion'], ['backed', 'Feeling backed up'], ['skin', "Skin that isn't as clear as I'd like"], ['habits', 'A stretch of alcohol or processed food'], ['exposure', 'Concern about environmental exposure']],
      next: function () { return 'format'; } },
    experience: { q: 'Have you done a cleanse before?',
      opts: [['never', 'Never'], ['some', 'Once or twice'], ['regular', 'I cleanse regularly']],
      next: function (s) { return resolve(s).primary === 'hl' ? 'size' : 'result'; } },
    size: { q: 'How long do you plan to use HolyLand?', sub: 'For best results we suggest at least 90 days of daily use.',
      opts: [['hl200', 'Trying it first', '200 g · 40 daily servings'], ['hl400', 'Committing to the full 90 days', '400 g · 80 daily servings, the better value']],
      next: function () { return 'result'; } }
  };
  var PATH_LEN = { detox: 6, gut: 4, reg: 4, liver: 4, unsure: 4 };
  var PDP = { zeo: ['exposure', 'detox'], hl200: ['exposure', 'detox'], hl400: ['exposure', 'detox'], liv: ['liverFocus', 'liver'], para: ['gut', 'gut'], go2: ['regHistory', 'reg'] };

  function list(a) { return a.length < 2 ? a.join('') : a.slice(0, -1).join(', ') + ' and ' + a[a.length - 1]; }
  function sizeKey(k, a) { return k === 'hl' ? (a.size || 'hl200') : k; }

  /* ---------- Decision rules ---------- */
  function resolve(s) {
    var a = s.answers, b = s.branch, primary = null, runner = null, why = [], runnerWhy = '', bits;
    if (b === 'detox') {
      var exp = a.exposure, fmt = a.format, inten = a.intensity;
      if (exp === 'high') primary = 'hl';
      else if (exp === 'everyday') primary = (fmt === 'powder' && inten === 'deep') ? 'hl' : 'zeo';
      else { var z = 0, h = 0; if (fmt === 'capsule') z++; if (fmt === 'powder') h++; if (inten === 'daily') z++; if (inten === 'deep') h++; primary = h > z ? 'hl' : 'zeo'; }
      bits = [];
      if (primary === 'hl') {
        runner = fmt === 'capsule' ? 'zeo' : 'liv';
        runnerWhy = fmt === 'capsule' ? 'Prefer capsules? ZeoForce gives you zeolite plus added herbs and minerals in a daily capsule.' : 'Add liver support alongside your binder for a complete cleanse.';
        if (exp === 'high') bits.push('higher exposure'); if (inten === 'deep') bits.push('wanting a deeper detox'); if (fmt === 'powder') bits.push('being happy with a powder');
        why.push((bits.length ? 'You mentioned ' + list(bits) + ', so ' : '') + "HolyLand's pure, therapeutic-dose powder is the better match.");
      } else {
        runner = (inten === 'deep' || exp === 'high') ? 'hl' : 'liv';
        runnerWhy = runner === 'hl' ? 'Want a stronger, pure binder? HolyLand is single-ingredient zeolite powder at a therapeutic dose.' : 'Pair it with LiVitalize for complete liver support.';
        if (exp === 'everyday') bits.push('everyday exposure'); if (fmt === 'capsule') bits.push('preferring capsules'); if (inten === 'daily') bits.push('wanting a simple daily routine');
        why.push((bits.length ? 'You mentioned ' + list(bits) + ', so ' : '') + 'ZeoForce fits: zeolite plus liver, kidney and absorption support in one daily capsule.');
      }
    }
    if (b === 'gut') {
      primary = 'para';
      if (a.paraReg === 'often') { runner = 'go2'; runnerWhy = "Since you're often backed up, GO-2 adds gentle overnight regularity support."; }
      else { runner = 'hl'; runnerWhy = 'Pair it with HolyLand for extra binder support during your cleanse.'; }
      var gm = { thorough: "you're ready for a thorough cleanse", balance: 'you want to support a healthy gut-flora and candida balance', offtrack: 'things feel off after travel, stress or a processed-food stretch' };
      why.push('Because ' + (gm[a.gut] || 'you want whole-gut support') + ", ParaCan-NXT's 4-phase cleanse covers herbs, binders and digestive comfort in 2 capsules a day.");
    }
    if (b === 'reg') {
      primary = 'go2';
      if (a.regGoal === 'deeper') { runner = 'para'; runnerWhy = 'For a deeper whole-gut cleanse, ParaCan-NXT adds herbs and binders.'; }
      var rh = { harsh: "Since harsh cleanses haven't worked for you, it helps that ", never: 'For a first colon cleanse, ' }[a.regHistory] || '';
      why.push(rh + 'GO-2 is built to be gentle and predictable: take it after dinner and wake up feeling lighter.');
      if (a.regGoal === 'fifteen') why.push('It comes with a simple 15-day cleanse schedule on the label.');
    }
    if (b === 'liver') {
      primary = 'liv';
      if (a.liverPair === 'capsule') { runner = 'zeo'; runnerWhy = 'Your binder pick in capsules: ZeoForce.'; }
      if (a.liverPair === 'powder') { runner = 'hl'; runnerWhy = 'Your binder pick as a powder: HolyLand Zeolite.'; }
      var lf = { energy: 'steadier, natural energy', digest: 'digestion and metabolism', skin: 'clearer-looking skin', habits: 'supporting your liver after a tough stretch' }[a.liverFocus];
      why.push('For ' + (lf || 'liver support') + ', LiVitalize goes beyond milk thistle with 28 ingredients in 2 capsules a day.');
    }
    if (b === 'unsure') {
      var sc = { zeo: 0, liv: 0, para: 0, go2: 0, hl: 0 }, picks = a.feel || [];
      var W = { foggy: { zeo: 2, liv: 1 }, bloated: { go2: 2, para: 1 }, backed: { go2: 3 }, skin: { liv: 1, hl: 1 }, habits: { liv: 2, para: 1 }, exposure: { zeo: 2, hl: 1 } };
      picks.forEach(function (p) { var w = W[p] || {}; Object.keys(w).forEach(function (k) { sc[k] += w[k]; }); });
      if (a.format === 'capsule' && sc.zeo > 0) sc.zeo += 1; if (a.format === 'powder' && sc.hl > 0) sc.hl += 1;
      var order = ['zeo', 'liv', 'para', 'go2', 'hl'];
      var ranked = order.slice().sort(function (x, y) { return sc[y] - sc[x] || order.indexOf(x) - order.indexOf(y); });
      primary = ranked[0]; runner = sc[ranked[1]] > 0 ? ranked[1] : null;
      var maxW = { foggy: 2, bloated: 2, backed: 3, skin: 1, habits: 2, exposure: 2 };
      s._scores = sc; s._max = Math.max(1, picks.reduce(function (t, p) { return t + (maxW[p] || 0); }, 0) + (a.format === 'either' ? 0 : 1));
      var labels = { foggy: 'feeling run-down', bloated: 'bloating', backed: 'feeling backed up', skin: 'skin', habits: 'a processed-food stretch', exposure: 'environmental exposure' };
      var hits = picks.filter(function (p) { return W[p] && W[p][primary]; }).map(function (p) { return labels[p]; });
      why.push((hits.length ? 'Based on ' + list(hits) + ', ' : 'Based on your answers, ') + '{NAME} is the closest fit.');
      if (runner) runnerWhy = 'Also scored well for what you described.';
    }
    if (a.experience === 'never') {
      why.push({ go2: 'Start with 1 capsule after dinner and adjust from there.', hl: 'Start with 1 scoop a day and drink plenty of water.', zeo: 'Take 3 capsules a day with a full glass of water.', liv: 'Take 2 capsules a day with food or a morning drink.', para: 'Take 2 capsules a day, ideally on an empty stomach, with plenty of water.' }[primary]);
    }
    var m = matchPct(s, primary, runner);
    return { primary: primary, runner: runner, why: why, runnerWhy: runnerWhy, pct: m[0], rpct: m[1] };
  }

  /* Match %: share of the shopper's answers that point to each product */
  function matchPct(s, primary, runner) {
    var a = s.answers, b = s.branch, agree = 0, total = 1, ragree = 0;
    function half(v, yes, no) { return v === yes ? 1 : (v === no ? 0 : 0.5); }
    if (b === 'detox') {
      total = 3;
      var toHl = half(a.exposure, 'high', 'everyday') + half(a.format, 'powder', 'capsule') + half(a.intensity, 'deep', 'daily');
      var toZeo = 3 - toHl;
      agree = primary === 'hl' ? toHl : toZeo;
      ragree = runner === 'hl' ? toHl : runner === 'zeo' ? toZeo : 1;
    }
    if (b === 'gut') { total = 2; agree = 1 + half(a.paraReg, 'regular', 'often'); ragree = runner === 'go2' ? (a.paraReg === 'often' ? 1.5 : 0.5) : 1; }
    if (b === 'reg') { total = 2; agree = 1 + (a.regGoal === 'deeper' ? 0.5 : 1); ragree = a.regGoal === 'deeper' ? 1.5 : 0; }
    if (b === 'liver') { total = 2; agree = 2; ragree = 1; }
    if (b === 'unsure') { var sc = s._scores || {}; total = s._max || 1; agree = sc[primary] || 0; ragree = runner ? (sc[runner] || 0) : 0; }
    var p = Math.min(98, Math.round(70 + 28 * Math.min(1, agree / total)));
    var r = runner ? Math.min(Math.round(50 + 32 * Math.min(1, ragree / total)), p - 6) : null;
    return [p, r];
  }

  /* ---------- One finder instance ---------- */
  function Finder(root, data) {
    this.root = root; this.P = data.products || {}; this.T = data.text || {};
    this.mode = root.getAttribute('data-mode') || 'inline';
    this.current = root.getAttribute('data-current') || '';
    this.open = this.mode === 'inline';
    this.reset();
    var self = this;
    root.addEventListener('click', function (e) { self.onClick(e); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && self.mode === 'popup' && self.open) { self.open = false; self.draw(); } });
    this.draw();
  }
  Finder.prototype.reset = function () { this.S = { screen: 'intro', branch: null, answers: {}, history: [], sel: null, added: {} }; };
  Finder.prototype.esc = function (t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  Finder.prototype.shortName = function (k) { var p = this.P[k]; return p ? String(p.name).replace(/,\s*\d+\s*g$/i, '') : ''; };

  Finder.prototype.introHTML = function () {
    var e = this.esc.bind(this), T = this.T;
    if (this.current && this.P[this.current]) {
      return '<div class="hbn-finder__step hbn-finder__fade"><span class="hbn-eyebrow">' + e(T.eyebrow) + '</span>' +
        '<h2 class="section-header__title h2 hbn-finder__title">Is ' + e(this.shortName(this.current)) + ' right for you?</h2>' +
        '<p class="hbn-finder__sub">' + e(T.pdpIntro) + '</p>' +
        '<div class="hbn-finder__actions"><button class="btn" type="button" data-act="startPdp">Find out</button><button class="hbn-finder__link" type="button" data-act="startAll">Compare all products instead</button></div></div>';
    }
    return '<div class="hbn-finder__step hbn-finder__fade"><span class="hbn-eyebrow">' + e(T.eyebrow) + '</span>' +
      '<h2 class="section-header__title h2 hbn-finder__title">' + e(T.title) + '</h2>' +
      '<p class="hbn-finder__sub">' + e(T.intro) + '</p>' +
      '<div class="hbn-finder__actions"><button class="btn" type="button" data-act="startAll">' + e(T.start || 'Start') + '</button></div></div>';
  };

  Finder.prototype.questionHTML = function (id) {
    var S = this.S, q = Q[id], e = this.esc.bind(this);
    var total = PATH_LEN[S.branch] || 6, done = S.history.length, pct = Math.min(96, Math.round(done / total * 100));
    var sel = S.sel || (q.multi ? [] : null);
    var on = function (v) { return q.multi ? sel.indexOf(v) > -1 : sel === v; };
    var two = q.opts.length >= 4 && !q.opts.some(function (o) { return o[2]; });
    var opts = q.opts.map(function (o) {
      return '<button type="button" class="hbn-finder__opt' + (q.multi ? ' is-multi' : '') + '" data-opt="' + o[0] + '" aria-pressed="' + on(o[0]) + '"><span class="hbn-finder__mark" aria-hidden="true"></span><span><span class="hbn-finder__opt-t">' + e(o[1]) + '</span>' + (o[2] ? '<span class="hbn-finder__opt-h">' + e(o[2]) + '</span>' : '') + '</span></button>';
    }).join('');
    var canNext = q.multi ? sel.length > 0 : !!sel;
    return '<div class="hbn-finder__step hbn-finder__fade">' +
      '<div class="hbn-finder__progress"><div class="hbn-finder__bar" role="progressbar" aria-valuenow="' + pct + '" aria-valuemin="0" aria-valuemax="100"><i style="width:' + pct + '%"></i></div><span>Question ' + (done + 1) + '</span></div>' +
      '<button class="hbn-finder__back" type="button" data-act="back">&larr; Back</button>' +
      '<p class="hbn-finder__q" id="' + this.uid + '-q">' + e(q.q) + '</p>' + (q.sub ? '<p class="hbn-finder__sub">' + e(q.sub) + '</p>' : '') +
      '<div class="hbn-finder__opts' + (two ? ' is-two' : '') + '" role="group" aria-labelledby="' + this.uid + '-q">' + opts + '</div>' +
      (q.multi ? '<div class="hbn-finder__actions"><button class="btn" type="button" data-act="next"' + (canNext ? '' : ' disabled') + '>Continue</button></div>' : '') + '</div>';
  };

  Finder.prototype.ring = function (p, cls) { return '<div class="hbn-finder__ring ' + cls + '" style="--p:' + p + '" role="img" aria-label="' + p + '% match"><span><b>' + p + '%</b><small>match</small></span></div>'; };

  Finder.prototype.resultHTML = function () {
    var S = this.S, a = S.answers, e = this.esc.bind(this), T = this.T;
    var r = resolve(S), pk = sizeKey(r.primary, a), p = this.P[pk];
    if (!p) return '<p>Sorry, we could not load the products. Please refresh the page.</p>';
    var rk = r.runner ? sizeKey(r.runner, a) : null, rp = rk ? this.P[rk] : null;
    var cur = this.current, same = !!cur && (cur === pk || (cur.indexOf('hl') === 0 && pk.indexOf('hl') === 0));
    var pdp = '';
    if (cur && this.P[cur]) pdp = same ? '<div class="hbn-finder__pdpnote">Good news: you\'re on the right page.</div>' : '<div class="hbn-finder__pdpnote">Based on your answers, ' + e(p.name) + ' may be a better fit than ' + e(this.shortName(cur)) + '.</div>';
    var why = r.why.filter(Boolean).join(' ').replace('{NAME}', p.name);
    var cta;
    if (same && pk === cur && p.variant && p.available) {
      cta = S.added[pk] ? '<a class="btn" href="/cart">View cart</a>' : '<button class="btn" type="button" data-add="' + pk + '">Add to cart · ' + e(p.price) + '</button>';
    } else {
      cta = '<a class="btn" href="' + e(p.url) + '">Shop ' + e(this.shortName(pk)) + '</a>';
    }
    return '<div class="hbn-finder__result hbn-finder__fade">' +
      '<span class="hbn-eyebrow">Your best match</span>' + pdp +
      '<div class="hbn-finder__match">' +
        '<div class="hbn-finder__visual">' + (p.image ? '<img src="' + e(p.image) + '" alt="' + e(p.name) + '" width="250" height="250" loading="lazy">' : '') + this.ring(r.pct, 'is-lg') + '</div>' +
        '<div class="hbn-finder__info">' + (p.label ? '<span class="hbn-badge">' + e(p.label) + '</span>' : '') +
          '<h3 class="hbn-finder__name">' + e(p.name) + '</h3>' +
          '<p class="hbn-finder__meta">' + (p.form ? e(p.form) + ' · ' : '') + e(p.price) + '</p>' +
          (p.hook ? '<p class="hbn-finder__hook">' + e(p.hook) + '</p>' : '') +
          '<div class="hbn-finder__why"><b>Why this fits you</b>' + e(why) + '</div>' +
          '<div class="hbn-finder__actions">' + cta + '</div>' +
        '</div></div>' +
      (rp ? '<div class="hbn-finder__runner">' + this.ring(r.rpct, 'is-sm') +
        (rp.image ? '<img class="hbn-finder__runner-img" src="' + e(rp.image) + '" alt="" width="64" height="64" loading="lazy">' : '') +
        '<div class="hbn-finder__runner-txt"><span class="hbn-finder__runner-lbl">Pairs well with</span><span class="hbn-finder__runner-name">' + e(rp.name) + ' · ' + e(rp.price) + '</span><span class="hbn-finder__runner-why">' + e(r.runnerWhy) + '</span></div>' +
        '<a class="btn btn--secondary btn--small" href="' + e(rp.url) + '">View</a></div>' : '') +
      '<div class="hbn-finder__actions"><button class="hbn-finder__link" type="button" data-act="restart">Start over</button></div>' +
      (T.note ? '<p class="hbn-finder__fine">' + e(T.note) + '</p>' : '') +
      (T.disclaimer ? '<p class="hbn-finder__fine">' + e(T.disclaimer) + '</p>' : '') +
      '</div>';
  };

  Finder.prototype.panelHTML = function () {
    var S = this.S;
    var inner = S.screen === 'intro' ? this.introHTML() : S.screen === 'result' ? this.resultHTML() : this.questionHTML(S.screen);
    return '<div class="hbn-finder" data-panel>' + inner + '</div>';
  };

  Finder.prototype.draw = function () {
    var e = this.esc.bind(this), T = this.T, html;
    if (this.mode === 'inline') html = this.panelHTML();
    else if (this.mode === 'compact') {
      html = this.open ? this.panelHTML() : '<div class="hbn-finder-teaser"><div><p class="hbn-finder-teaser__t">' + e(T.teaserTitle) + '</p><p class="hbn-finder__sub">' + e(T.teaserText) + '</p></div><button class="btn" type="button" data-act="openPanel">' + e(T.button || 'Find my match') + '</button></div>';
    } else {
      html = '<div class="hbn-finder-launch"><p class="hbn-finder-teaser__t">' + e(T.teaserTitle) + '</p><button class="btn" type="button" data-act="openPanel">' + e(T.button || 'Find my match') + '</button></div>' +
        (this.open ? '<div class="hbn-finder-overlay" data-act="overlay"><div class="hbn-finder-modal" role="dialog" aria-modal="true" aria-label="Product finder"><button class="hbn-finder-close" type="button" data-act="close" aria-label="Close">&times;</button>' + this.panelHTML() + '</div></div>' : '');
    }
    this.root.innerHTML = html;
    if (this.mode === 'popup') document.documentElement.classList.toggle('hbn-finder-locked', this.open);
  };

  Finder.prototype.go = function (id) {
    var S = this.S;
    if (S.screen !== 'intro' && S.screen !== 'result') S.history.push(S.screen);
    S.screen = id;
    S.sel = Q[id] && Q[id].multi ? (S.answers[id] || []).slice() : (S.answers[id] || null);
    this.draw(); this.focusPanel();
  };
  Finder.prototype.focusPanel = function () {
    var panel = this.root.querySelector('[data-panel]'); if (!panel) return;
    var q = panel.querySelector('.hbn-finder__q, .hbn-finder__result');
    if (q) { q.setAttribute('tabindex', '-1'); q.focus({ preventScroll: true }); }
    if (this.mode !== 'popup') { var top = panel.getBoundingClientRect().top; if (top < 0) panel.scrollIntoView({ block: 'start', behavior: 'smooth' }); }
  };
  Finder.prototype.answer = function (id, val) {
    var S = this.S; S.answers[id] = val;
    if (id === 'start') S.branch = val;
    if (id === 'gut') S.branch = val === 'bloat' ? 'reg' : 'gut';
    this.go(Q[id].next(S, val));
  };
  Finder.prototype.addToCart = function (key, btn) {
    var self = this, p = this.P[key]; if (!p || !p.variant) return;
    btn.disabled = true; btn.textContent = 'Adding…';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: p.variant, quantity: 1 }] }) })
      .then(function (res) { if (!res.ok) throw new Error('add failed'); return res.json(); })
      .then(function (json) {
        self.S.added[key] = true; self.draw();
        var item = json && json.items ? json.items[0] : json;
        /* Impulse listens for these to refresh and open the cart drawer */
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: item, addToCartBtn: null } }));
        document.dispatchEvent(new CustomEvent('cart:build'));
      })
      .catch(function () { btn.disabled = false; btn.textContent = 'Could not add. Try again'; });
  };
  Finder.prototype.onClick = function (e) {
    var t = e.target.closest('[data-act],[data-opt],[data-add]'); if (!t || !this.root.contains(t)) return;
    var S = this.S, self = this;
    if (t.hasAttribute('data-add')) { this.addToCart(t.getAttribute('data-add'), t); return; }
    if (t.hasAttribute('data-opt')) {
      var id = S.screen, q = Q[id], v = t.getAttribute('data-opt');
      if (q.multi) { var s = S.sel || []; s = s.indexOf(v) > -1 ? s.filter(function (x) { return x !== v; }) : s.concat(v); S.sel = s; this.draw(); }
      else { S.sel = v; this.draw(); setTimeout(function () { self.answer(id, v); }, 180); }
      return;
    }
    var act = t.getAttribute('data-act');
    if (act === 'overlay' && e.target !== t) return;
    switch (act) {
      case 'next': this.answer(S.screen, S.sel.slice()); break;
      case 'startAll': this.reset(); this.S.screen = 'start'; this.draw(); this.focusPanel(); break;
      case 'startPdp': var c = PDP[this.current]; this.reset(); this.S.branch = c[1]; this.S.screen = c[0]; this.draw(); this.focusPanel(); break;
      case 'back':
        var prev = S.history.pop();
        if (!prev) { this.reset(); }
        else { S.screen = prev; if (prev === 'start') S.branch = null; S.sel = Q[prev].multi ? (S.answers[prev] || []).slice() : (S.answers[prev] || null); }
        this.draw(); break;
      case 'restart': this.reset(); this.draw(); this.focusPanel(); break;
      case 'openPanel': this.open = true; this.draw(); this.focusPanel(); break;
      case 'close': case 'overlay': this.open = false; this.draw(); break;
    }
  };

  var n = 0;
  function boot() {
    document.querySelectorAll('[data-hbn-finder]').forEach(function (root) {
      if (root.__hbnFinder) return;
      var holder = root.closest('.hbn-finder-section'), json = holder && holder.querySelector('[data-hbn-finder-data]');
      var data = {}; try { data = JSON.parse(json.textContent); } catch (err) { return; }
      root.__hbnFinder = true;
      var f = Object.create(Finder.prototype); f.uid = 'hbnf' + (++n); Finder.call(f, root, data);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
